import Page from 'components/layout/Page';
import Faqs from 'components/marketingSite/shared/Faqs';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import {
  StyledCompanies,
  StyledHeroImage,
  StyledHeroWrapper
} from './CompaniesComponent.styled';
import { CustomersItem, StatsItem } from './CompaniesComponent.types';
import Customers from './sections/customers/Customers';
import Data from './sections/data/Data';
import Hero from './sections/heroForm/Hero';

type ContentProps = {
  stats: StatsItem[];
  customers: CustomersItem[];
  manfreditesCount: number;
};

const CompaniesFormComponent: React.FC<ContentProps> = ({
  stats,
  customers,
  manfreditesCount
}) => {
  const { t } = useI18n('companies2');

  const faqs = [
    {
      question: t('companies.faqs.faqsList.faq1.question'),
      answer: (
        <HtmlTrans
          ns={'companies2'}
          i18nKey={'companies.faqs.faqsList.faq1.answer'}
        ></HtmlTrans>
      ),
      renderComponent: true
    },
    {
      question: t('companies.faqs.faqsList.faq2.question'),
      answer: (
        <HtmlTrans
          ns={'companies2'}
          i18nKey={'companies.faqs.faqsList.faq2.answer'}
        ></HtmlTrans>
      ),
      renderComponent: true
    },
    {
      question: t('companies.faqs.faqsList.faq3.question'),
      answer: (
        <HtmlTrans
          ns={'companies2'}
          i18nKey={'companies.faqs.faqsList.faq3.answer'}
        ></HtmlTrans>
      ),
      renderComponent: true
    },
    {
      question: t('companies.faqs.faqsList.faq4.question'),
      answer: (
        <HtmlTrans
          ns={'companies2'}
          i18nKey={'companies.faqs.faqsList.faq4.answer'}
        ></HtmlTrans>
      ),
      renderComponent: true
    },
    {
      question: t('companies.faqs.faqsList.faq5.question'),
      answer: (
        <HtmlTrans
          ns={'companies2'}
          i18nKey={'companies.faqs.faqsList.faq5.answer'}
        ></HtmlTrans>
      ),
      renderComponent: true
    }
  ];

  return (
    <Page hasScrollTop>
      <StyledCompanies>
        <StyledHeroWrapper className="companiesForm">
          <Hero />
          <StyledHeroImage>
            <img
              src={getPublicPath('/images/companies/stars-business.svg')}
              alt=""
              className="stars"
            />
            <img
              src={getPublicPath('/images/companies/astronaut2.svg')}
              alt=""
              className="astronaut"
            />
          </StyledHeroImage>
        </StyledHeroWrapper>
        <Customers customers={customers} />
        <Data
          className="companiesForm"
          stats={stats}
          manfreditesCount={manfreditesCount}
        />
        <Faqs
          faqs={faqs}
          title={t('companies.faqs.title')}
          desc={t('companies.faqs.desc')}
        />
      </StyledCompanies>
    </Page>
  );
};

export default CompaniesFormComponent;
